/**
 * Common GraphQL error types that can be returned by the API
 * Used across the application for consistent error handling
 */
export const GRAPHQL_ERROR_TYPES = [
  'InternalErrorV2',
  'ValidationErrorV2',
  'IntegrityErrorV2',
  'NotFoundErrorV2',
  'NotAuthenticatedErrorV2',
  'ForbiddenErrorV2',
  'MutationInternalExistsError',
  'MutationValidationExistsError',
] as const;
